import React, { useContext, useEffect, useState } from 'react';
import Card from '../../../component/Card';
import moment from 'moment';
import { AdminContext } from '../index';

const Profile = ({ isShow = true, data, backHome }) => {
  const [ tanggal, setTanggal ] = useState(new Date());
  const { contextData } = useContext(AdminContext);
  const { tanggalKunjungan } = contextData;
  const visitDate = data.visit_date_history || data.update_visit_date;

  useEffect(() => {
    console.log('update tanggal');

    visitDate && visitDate[ visitDate.length - 1 ]
      ? setTanggal((state) => visitDate[ visitDate.length - 1 ].visit_date)
      : setTanggal((state) => tanggalKunjungan);
  }, [ visitDate ]);

  useEffect(() => {
    tanggalKunjungan && setTanggal((state) => tanggalKunjungan);
  }, [ tanggalKunjungan ]);

  if (!isShow) return '';
  return (
    <>
      <div className='container-fluid '>
        <div className='row justify-content-center'>
          <div className='col-lg-12'>
            <Card marginTop={ 2 }>
              <Card.Body>
                <span
                  className='text-primary mb-3 d-block'
                  style={ { cursor: 'pointer' } }
                  onClick={ backHome }>
                  <i
                    className='ni ni-curved-next mr-2'
                    style={ { transform: 'scaleX(-1)' } }
                  />
                  <span className='d-inline'>Kembali</span>
                </span>
                <h2>Profil Pemohon</h2>
                <div className='row'>
                  <div className='col-md-5 col-sm-12'>
                    <div className='row'>
                      <div className='col-md-5'>ID Pendaftaran</div>
                      <div className='col-md-7'>
                        <b>{data.id}</b>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-md-5'>Nama Pemohon</div>
                      <div className='col-md-7'>
                        <b>
                          {`${ data.patient.name } ${ data.patient.last_name }`}
                        </b>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-md-5'>No Telepon</div>
                      <div className='col-md-7'>
                        <b>{data.patient.contact}</b>
                      </div>
                    </div>
                  </div>
                  <div className='col-md-7 col-sm-12'>
                    <div className='row'>
                      <div className='col-md-4'>Nama Perusahaan</div>
                      <div className='col-md-7'>
                        <b>{data.company_name}</b>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-md-4'>Alamat Perusahaan</div>
                      <div className='col-md-7'>
                        <b>{data.address}</b>
                      </div>
                    </div>
                    {visitDate[ visitDate.length - 1 ] || tanggalKunjungan ? (
                      <div className='row'>
                        <div className='col-md-4'>Tanggal Kunjungan</div>
                        <div className='col-md-7 text-success'>
                          <b>{moment(tanggal).format('DD-MM-YYYY')}</b>
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
